/*
 * Purpose: Compact version badge — header / footer
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { APP_ROUTES } from '@/lib/appRoutes';
import { VERSION_DISPLAY } from '@/lib/appVersion';

export function AppVersionBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={`text-[10px] font-normal tabular-nums shrink-0 ${className ?? ''}`}
      asChild
    >
      <Link to={`${APP_ROUTES.help}?tab=about`} title="Version & legal">
        {VERSION_DISPLAY}
      </Link>
    </Badge>
  );
}
